import { ThemeProvider as SharedThemeProvider } from '@myosh/design-system/react';
import type { ReactNode } from 'react';
import { useGetThemeQuery } from '@/api/generated/restV4-api';

interface ThemeContextProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeContextProps) => {
  const { data } = useGetThemeQuery();

  return <SharedThemeProvider data={data}>{children}</SharedThemeProvider>;
};
